import React, { useEffect } from "react";
import "./MadeInIndia.css";
import lionImage from "../Assessts/homeImages/lion8.png"; 

const MadeInIndia = () => {
  useEffect(() => {
    const section = document.querySelector(".made-in-india__section");

    const handleScroll = () => {
      const sectionTop = section.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (sectionTop < windowHeight) {
        section.classList.add("in-view");
      } else {
        section.classList.remove("in-view");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); 
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="made-in-india__section">
     
      <img
        src={lionImage}
        alt="Made in India"
        className="made-in-india__background"
      />

      {/* Overlay with content */}
      <div className="made-in-india__overlay">
        <div className="made-in-india__content">
          <h1>PROUDLY MADE IN INDIA</h1>
          <h2>Delivering Precision And Performance</h2>
          <p>
At Technocrat Aerospace & Defence (TAAD), we take immense pride in our identity as a truly "Proudly Made in India" company. Our commitment to indigenous development and manufacturing is aligned with the vision of Atmanirbhar Bharat—a self-reliant India—where cutting-edge aerospace and defense technologies are designed, developed, and produced domestically. By leveraging advanced engineering capabilities and deep industry expertise, we provide mission-critical products such as DAQ systems, RF and microwave modules, rugged embedded computing, avionics interfaces, sensors, and PCB assemblies that meet global standards while being manufactured locally.

          </p>
        </div>
      </div>
      <div></div>
    </section>
  );
};

export default MadeInIndia;
